import React, { Component } from 'react'

import Team from '../components/team/team'
import Footer from '../components/ladakh/footer/footer'
import Header from '../components/header'
import ReactGA from 'react-ga';

class TeamList extends Component {

  render() {
    const trackingId = "UA-24117780-3"; // Replace with your Google Analytics tracking ID
    ReactGA.initialize(trackingId);
    return (
      <div className='news-page'>
        <Header />
        <Team />
        <Footer />
      </div>
    );
  }
}

export default TeamList;
